import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { message, Spin } from "antd";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";

import englishJson from './utils/language/leStudy/english.json';
import spanishJson from './utils/language/leStudy/spanish.json';
import noLanguageJson from './utils/language/leStudy/noLanguage.json';

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      percentage: 0,
      is_voice_recording_is_completed: false,
      voice_recording_link: "",
      client_code: "",
      loading: false,
      is_voice_recording_value_yes: false,
    };
  }
  componentDidMount() {
    this.get_demographic_percentage();
  }
  get_demographic_percentage = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    if (RESEARCH_TYPE == "Asymptomatic Study") {
      this.setState({ loading: true });
      Bridge.demographics
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            this.setState({ percentage: response.percentage });
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "ECAS Study") {
      this.setState({ loading: true });
      Bridge.demographics.ecas_study
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            this.setState({ percentage: response.percentage });
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "modality.ai") {
      this.setState({ loading: true });
      let params =
        "?participants_accounts_id=" +
        localStorage.getItem("ap_participants_accounts_id");
      Bridge.demographics.speech
        .check_als_user(params)
        .then((response) => {
          if (response.status == "1") {
            this.setState(
              {
                percentage: response.data.percentage.toFixed(0),
                is_voice_recording_is_completed:
                  response.data.is_video_recording_is_completed,
              },
              () => this.get_speech_client_code()
            );
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "LE Study") {
      this.setState({ loading: true });
      let params =
        "?eals_id=" +
        localStorage.getItem("ap_eals_id") +
        "&relation_to_als=" +
        localStorage.getItem("ap_relation_to_als");
      this.setState({ loading: true });
      Bridge.demographics.le_study
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            this.setState({ percentage: response.percentage });
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    } else {
      this.setState({ percentage: 0, loading: false });
    }
  };
  get_speech_client_code = () => {
    let params =
      `?participants_accounts_id=` +
      localStorage.getItem("ap_participants_accounts_id");
    this.setState({ loading: true });
    Bridge.personal_data_viewer.speech
      .get_speech_client_code(params)
      .then((res) => {
        if (res.status == 1) {
          let speech_portal_link = res.data.portal_link;
          let client_code = res.data.client_code;
          let link = "";
          if (speech_portal_link) {
            link = speech_portal_link;
          } else if (client_code) {
            link = `https://webapi.modality.ai/avdialogue/prod/12/html/call.html?x=1230&i=${client_code}`;
          } else {
            link = "";
          }
          this.setState({
            voice_recording_link: link,
            is_voice_recording_value_yes: res.data.is_voice_recording_value_yes,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  open_voice_recording = () => {
    if (this.state.is_voice_recording_value_yes == false) {
      window.location.assign("/voice-recording-acknowledgment");
      return;
    } else if (this.state.is_voice_recording_is_completed == true) {
      let link = this.state.voice_recording_link;
      if (link) {
        window.open(link, "_blank");
      } else {
        message.warning("Please submit complete demographics form.");
        return;
      }
    } else {
      window.location.assign("/voice-recording-acknowledgment");
    }
  };
  render() {
    let formData = RESEARCH_TYPE === "LE Study"
      ? this.props.language === "English"
        ? englishJson
        : this.props.language === "Spanish"
          ? spanishJson
          : noLanguageJson
      : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-wrapper">
          <Spin spinning={this.state.loading}>
            <div className="container" style={{ minHeight: 300 }}>
              <div className="row">
                {RESEARCH_TYPE == "LE Study" ? (
                  <div className="col-lg-8 m-auto">
                    <div className="single-account">
                      <a
                        href={
                          this.state.percentage == "100"
                            ? "/about-me"
                            : "/basic-details"
                        }
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">{formData.page.sectionNames.aboutMe}</h4>
                            <div
                              className={
                                this.state.percentage == "100"
                                  ? "completed-per yes"
                                  : "completed-per not"
                              }
                            >
                              {this.state.percentage == "100"
                                ? ""
                                : this.state.percentage + "%"}{" "}
                              {formData.page.relatedWords.completed}
                            </div>
                          </div>
                          <a
                            href={
                              this.state.percentage == "100"
                                ? "/about-me"
                                : "/basic-details"
                            }
                            className="update-button"
                          >
                            {formData.page.next}{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href={"/view-consent-form"}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">{formData.page.sectionNames.viewConsentForm}</h4>
                          </div>
                          <a
                            href={"/view-consent-form"}
                            className="update-button"
                          >
                            {formData.page.next}{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href={"/my-personal-data-viewer"}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <h4>{formData.page.sectionNames.myPersonalDataViewer}</h4>
                          <a
                            href="/my-personal-data-viewer"
                            className="update-button"
                          >
                            {formData.page.next}{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href={"/download-everything-als-app"}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              {formData.page.sectionNames.downloadTheEverythingAlsApp}
                            </h4>
                          </div>
                          <a
                            href={"/download-everything-als-app"}
                            className="update-button"
                          >
                            {formData.page.next}{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-8 m-auto">
                    {RESEARCH_TYPE == "modality.ai" ? (
                      <div className="single-account">
                        <a
                          href={
                            this.state.percentage == "100"
                              ? "/about-me"
                              : "/basic-details"
                          }
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">About Me</h4>
                              <div
                                className={
                                  this.state.percentage == "100"
                                    ? "completed-per yes"
                                    : "completed-per not"
                                }
                              >
                                {this.state.percentage == "100"
                                  ? ""
                                  : this.state.percentage + "%"}{" "}
                                Completed
                              </div>
                            </div>
                            <a
                              href={
                                this.state.percentage == "100"
                                  ? "/about-me"
                                  : "/basic-details"
                              }
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    ) : (
                      <div className="single-account">
                        <a
                          href={
                            this.state.percentage == "100"
                              ? "/about-me"
                              : "/basic-details"
                          }
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">About Me</h4>
                              <div
                                className={
                                  this.state.percentage == "100"
                                    ? "completed-per yes"
                                    : "completed-per not"
                                }
                              >
                                {this.state.percentage == "100"
                                  ? ""
                                  : this.state.percentage + "%"}{" "}
                                Completed
                              </div>
                            </div>
                            <a
                              href={
                                this.state.percentage == "100"
                                  ? "/about-me"
                                  : "/basic-details"
                              }
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    {RESEARCH_TYPE == "modality.ai" && (
                      <div className="single-account voice-recording-sec">
                        <a
                          href="#"
                          style={{ textDecoration: "none" }}
                          onClick={() => this.open_voice_recording()}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              {this.state.is_voice_recording_is_completed ==
                              true ? (
                                <h4 className="mb-0 pb-0">
                                  I Want To Record My Voice
                                </h4>
                              ) : (
                                <h4 className="mb-0 pb-0">
                                  Voice Recording Acknowledgment
                                </h4>
                              )}
                              {this.state.is_voice_recording_value_yes ==
                              true ? (
                                <div className="completed-per yes">
                                  Completed
                                </div>
                              ) : (
                                <div className="completed-per not">
                                  {"0%"} Completed
                                </div>
                              )}
                            </div>
                            <a href="#" className="update-button">
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    {RESEARCH_TYPE == "modality.ai" && (
                      <div className="single-account">
                        <a
                          href="/update-alsfrs-and-roads"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">
                                Update ALSFRS-R and ROADS
                              </h4>
                            </div>
                            <a
                              href="/update-alsfrs-and-roads"
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    {RESEARCH_TYPE == "ECAS Study" && (
                      <div className="single-account">
                        <a
                          href={"/add-ecas-alsfrs-r-score"}
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">ALSFRS-R</h4>
                            </div>
                            <a
                              href={"/add-ecas-alsfrs-r-score"}
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    <div className="single-account">
                      <a
                        href={"/view-consent-form"}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">View Consent Form</h4>
                          </div>
                          <a
                            href={"/view-consent-form"}
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    {RESEARCH_TYPE == "Asymptomatic Study" && (
                      <div className="single-account">
                        <a
                          href={"/upload-pdf-for-genetic-confirmation"}
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">
                                Upload PDF of Genetic Testing Confirmation
                              </h4>
                            </div>
                            <a
                              href={"/upload-pdf-for-genetic-confirmation"}
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    <div className="single-account">
                      <a
                        href={"/my-personal-data-viewer"}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <h4>My Personal Data Viewer</h4>
                          <a
                            href="/my-personal-data-viewer"
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Spin>
        </div>
        <Footer />
      </div>
    );
  }
}
